import { render, staticRenderFns } from "./SinOrden.vue?vue&type=template&id=6cc82ac8"
import script from "./SinOrden.vue?vue&type=script&lang=js"
export * from "./SinOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports